// extracted by mini-css-extract-plugin
export default {"rowHasBadge":"KG-z","smallCardRow":"LG-z","largeCardRow":"MG-z","productSearchRow":"NG-z","curatedRow":"OG-z"};